import React from 'react';
import styled from '@emotion/styled';
import Body1 from '../Typography/Body/Body1';
import CheckIcon from '../Icons/Check';

const List = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
`;

export const CheckItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
`;

export const CheckIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: rgba(
    76, 175, 80, 0.1
  );
`;

interface FeatureCheckListProperties {
  features: string[];
}

const FeatureCheckList = ({
  features,
}: FeatureCheckListProperties) => (
  <List>
    {features.map((feature) => (
      <CheckItem key={feature}>
        <CheckIconWrapper>
          <CheckIcon />
        </CheckIconWrapper>
        <Body1>{feature}</Body1>
      </CheckItem>
    ))}
  </List>
);

export default FeatureCheckList;
